import { configureStore } from '@reduxjs/toolkit';
// import chatReducer from './features/chat/chatSlice';
import chatSlice from './features/chat/chatSlice';
import layoutSlice from './features/chat/layoutSlice';
import staticDataSlice from './features/staticDataSlice';
import rfqDataSlice from './features/rfqDataSlice';

export const store = configureStore({
  reducer: {
    chat: chatSlice,
    layout:layoutSlice,
    staticList:staticDataSlice,
    rfqData:rfqDataSlice
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
